import type { ModelConfigView } from '@autopilot/contracts';

/** MOCK-Modelle brauchen keinen Schlüssel (Backend-Antwort Punkt 1). */
export function secretRequired(m: Pick<ModelConfigView, 'provider'>): boolean {
  return m.provider !== 'MOCK';
}

export function modelUsable(m: Pick<ModelConfigView, 'provider' | 'active' | 'secret'>): boolean {
  return m.active && (m.secret.configured || !secretRequired(m));
}
